import ManageAdminPage from './ManageAdminPage';
import { checkUserRole } from '../../Auth';
import { UserRole } from '../../../models';

export default checkUserRole(ManageAdminPage, [UserRole.superAdmin], '/admin');
export { default as reducer } from './admin.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdminPage/index.ts